import React from 'react';
import { BanIcon, LockIcon, TimerIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const badges = [{
  icon: LockIcon,
  label: 'Video seguro'
}, {
  icon: BanIcon,
  label: 'Sin anuncios'
}, {
  icon: TimerIcon,
  label: 'Menos de 05 min'
}];
export function VideoSection() {
  return <section className="w-full bg-cream py-16" data-id="element-180" data-mp="1irv6l1ok2lv2">
      <div className="mx-auto max-w-[800px] px-5 text-center sm:px-6" data-id="element-181" data-mp="1ir3bdryveq5b">
        <Reveal data-id="element-182" data-mp="1wr4dtbusa5mw">
          <span className="inline-flex rounded-full border border-gold px-3.5 py-1 text-[12px] font-semibold text-forest" data-id="element-183" data-mp="1wql1canwk9g9">
            Mira esto antes de seguir
          </span>

          <h2 className="mx-auto mt-5 max-w-2xl text-[26px] font-bold leading-tight tracking-tight text-forest sm:text-[32px]" data-id="element-184" data-mp="26gxpecuxekr5">
            Descubre Exactamente Cómo Funciona el Método de Vaciado Biológico
          </h2>

          <p className="mx-auto mt-3 max-w-xl text-base font-normal leading-relaxed text-warmgray" data-id="element-185" data-mp="2fix4v0qalgrz">
            Este video de pocos minutos explica lo que los médicos convencionales nunca te contarán
            sobre los parásitos modernos.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-186" data-mp="ywbk8caobr00">
          <div className="mt-8 overflow-hidden rounded-2xl border-2 border-gold shadow-2xl" data-id="element-187" data-mp="yvk1i226dnr5">
            <div className="aspect-video w-full bg-forest-deep" data-id="element-188" data-mp="13t20azmhamlf">
              <iframe src="https://player.cloudinary.com/embed/?cloud_name=lkfj1jku&public_id=VSL_Baciado" title="Video: cómo funciona el Método de Vaciado Biológico" className="h-full w-full" allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowFullScreen frameBorder="0" data-id="element-189" data-mp="18tpzw9orwbr9" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} data-id="element-190" data-mp="1mmxtu80btjc4">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-191" data-mp="1rjo7ypskm4uw">
            {badges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-[13px] font-semibold text-warmgray" data-id="element-192" data-mp="1wgxv1yshm4fk">
                <Icon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-193" data-mp="21frahwrc45id" />
                {label}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}